export default {
  updateObservation (state, value) {
    state.observation = value
  },
  updateSatisfaction (state, value) {
    state.satisfaction = value
  },
  loadLogoProvider (state, payload) {
    state.logoProviderFeedback = payload.logo
    state.loadingFeedback = false
  },
  toggleLoadingFeedback (state, value) {
    state.loadingFeedback = value
  }
}



// WEBPACK FOOTER //
// ./src/store/hotsite/feedback/mutations.js